/* eslint-disable prettier/prettier */
/* eslint-disable react/button-has-type */
/* eslint-disable no-return-assign */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext, useState, useEffect } from "react";
import { Box } from "@mui/material";
import * as Sentry from "@sentry/react";
import EditIcon from "@mui/icons-material/Edit";
import Styles from "./styles";
import Button from "../../../components/common/Button";
import ControlPanelAPI from "../../../services/api/controlpanel";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus, PERMISSIONS } from "../../../contants";
import Loader from "../../../components/common/Loader/Loader";
import useUserConfig from "../../../hooks/useUserConfig";
import SettingModal from "./SettingModal";

function ControlPanel() {
  const toast = useContext(ToastAlertContext);
  const [isLoading, setIsLoading] = useState(false);
  const hasPermission = useUserConfig();

  const [settings, setSettings] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [grouped, setGrouped] = useState({});

  const fetchSettings = async () => {
    try {
      const res = await ControlPanelAPI.getAllSettings();
      if (res.data && Array.isArray(res.data)) {
        setSettings(res.data);
      } else if (res.data && Array.isArray(res.data.data)) {
        setSettings(res.data.data);
      } else {
        setSettings([]);
      }
    } catch (err) {
      toast.show("Failed to fetch settings", AlertStatus.ERROR);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  useEffect(() => {
    if (Array.isArray(settings)) {
      const data = settings.reduce((acc, item) => {
        const section = item.key.split("_")[0];
        if (!acc[section]) acc[section] = [];
        acc[section].push(item);
        return acc;
      }, {});
      setGrouped(data);
    }
  }, [settings]);

  const dataTypeColors = {
    boolean: "#16a34a",
    varchar: "#2563eb",
    int: "#d97706",
    json: "#7c3aed",
    default: "#6b7280",
  };

  const handleSyncRolesAndPermission = async () => {
    try {
      setIsLoading(true);
      const response = await ControlPanelAPI.syncRolesAndPermission();
      if (response.code === 200) {
        toast.show("Roles and Permissions synced successfully", AlertStatus.SUCCESS);
      }
    } catch (error) {
      toast.show("Something went wrong.", AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAttendanceUnmarkedEmailer = async () => {
    try {
      setIsLoading(true);
      const response = await ControlPanelAPI.emailUnmarkedStructures();
      if (response.code === 200) {
        toast.show("Email sent successfully", AlertStatus.SUCCESS);
      }
    } catch (error) {
      toast.show("Something went wrong.", AlertStatus.ERROR);
      Sentry.captureException(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = () => {
    setEditData(null);
    setModalOpen(true);
  };

  const handleEdit = (setting) => {
    setEditData(setting);
    setModalOpen(true);
  };

  const handleSubmit = async (data) => {
    try {
      if (editData) {
        await ControlPanelAPI.updateSetting(editData.id, data);
        toast.show("Setting updated successfully", AlertStatus.SUCCESS);
      } else {
        await ControlPanelAPI.createNewSetting(data);
        toast.show("Setting added successfully", AlertStatus.SUCCESS);
      }
      fetchSettings();
    } catch {
      toast.show("Failed to save setting", AlertStatus.ERROR);
    }
  };

  const buttonConfigs = [
    {
      label: "Sync Roles and Permissions",
      style: Styles.syncRolesPermissions,
      width: "30%",
      onClick: handleSyncRolesAndPermission,
    },
    ...(hasPermission(PERMISSIONS.UNMARKED_STRUCTURE_EMAIL)
      ? [
        {
          label: "Attendance Unmarked Emailer",
          style: Styles.attendanceUnmarkedEmailer,
          width: "30%",
          onClick: handleAttendanceUnmarkedEmailer,
        },
      ]
      : []),
  ];

  return (
    <div style={Styles.container}>
      <Box>
        <Box
          sx={{
            ...Styles.boxStyle,
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          {buttonConfigs.map((config, index) => (
            <Button
              key={index}
              variant="contained"
              label={config.label}
              style={{
                ...Styles.buttonBaseStyle,
                ...config.style,
                width: config.width,
              }}
              onClick={config.onClick}
            />
          ))}
          <Button
            variant="contained"
            label="Add Setting"
            onClick={handleAdd}
            style={{ marginLeft: "auto" }}
          />
        </Box>

        <Box sx={{ mt: 4 }}>
          <Box
            sx={{
              borderRadius: "12px",
              overflow: "hidden",
              background: "#ffffff",
              border: "1px solid #BFDBFE",
              boxShadow: "0 2px 12px rgba(59, 130, 246, 0.08)",
            }}
          >
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
              <thead>
                <tr style={{ background: "linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%)" }}>
                  {["#", "Key", "Value", "Type", "Action"].map((col) => (
                    <th
                      key={col}
                      style={{
                        padding: "13px 16px",
                        color: "#ffffff",
                        fontWeight: "600",
                        fontSize: "12px",
                        textTransform: "uppercase",
                        letterSpacing: "0.6px",
                        textAlign: col === "#" || col === "Action" ? "center" : "left",
                      }}
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {(() => {
                  let serial = 1;

                  return Object.keys(grouped).map((sec) => (
                    <React.Fragment key={sec}>
                      {grouped[sec].map((s) => {
                        const currentSerial = serial;
                        serial += 1;
                        const isEven = currentSerial % 2 === 0;

                        return (
                          <tr
                            key={s.id}
                            style={{
                              background: isEven ? "#F0F7FF" : "#ffffff",
                              borderBottom: "1px solid #DBEAFE",
                              transition: "background 0.15s ease",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#DBEAFE")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = isEven ? "#F0F7FF" : "#ffffff")
                            }
                          >
                            <td
                              style={{
                                padding: "12px 16px",
                                textAlign: "center",
                                color: "#64748B",
                                fontWeight: "600",
                                fontSize: "13px",
                                width: "50px",
                              }}
                            >
                              {currentSerial}
                            </td>

                            <td
                              style={{
                                padding: "12px 16px",
                                color: "#1E3A5F",
                                fontWeight: "500",
                                fontFamily: "monospace",
                                fontSize: "13px",
                              }}
                            >
                              {s.key}
                            </td>

                            <td style={{ padding: "12px 16px" }}>
                              {s.dataType === "boolean" ? (
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "3px 10px",
                                    borderRadius: "20px",
                                    fontSize: "11.5px",
                                    fontWeight: "700",
                                    background: s.value === "true" ? "#DCFCE7" : "#FEE2E2",
                                    color: s.value === "true" ? "#15803D" : "#DC2626",
                                    letterSpacing: "0.3px",
                                  }}
                                >
                                  {s.value === "true" ? "ACTIVE" : "INACTIVE"}
                                </span>
                              ) : (
                                <span style={{ color: "#334155", fontSize: "13px" }}>
                                  {s.value}
                                </span>
                              )}
                            </td>

                            <td style={{ padding: "12px 16px" }}>
                              <span
                                style={{
                                  color: dataTypeColors[s.dataType] || dataTypeColors.default,
                                  fontWeight: "600",
                                  fontSize: "12.5px",
                                  background: `${dataTypeColors[s.dataType] || dataTypeColors.default}15`,
                                  padding: "2px 8px",
                                  borderRadius: "5px",
                                }}
                              >
                                {s.dataType}
                              </span>
                            </td>

                            <td style={{ padding: "12px 16px", textAlign: "center", width: "70px" }}>
                              <button
                                onClick={() => handleEdit(s)}
                                style={{
                                  background: "transparent",
                                  border: "1.5px solid #BFDBFE",
                                  borderRadius: "7px",
                                  padding: "5px 7px",
                                  cursor: "pointer",
                                  color: "#2563EB",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transition: "all 0.15s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = "#2563EB";
                                  e.currentTarget.style.color = "#fff";
                                  e.currentTarget.style.borderColor = "#2563EB";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = "transparent";
                                  e.currentTarget.style.color = "#2563EB";
                                  e.currentTarget.style.borderColor = "#BFDBFE";
                                }}
                              >
                                <EditIcon style={{ fontSize: "16px" }} />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  ));
                })()}
              </tbody>
            </table>
          </Box>
        </Box>

        {modalOpen && (
          <SettingModal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            onSubmit={handleSubmit}
            initialData={editData}
          />
        )}
      </Box>

      {isLoading && <Loader />}
    </div>
  );
}

export default ControlPanel;
